export const REPORTING_FORMAT_OPTIONS = [
  'Excel',
  'PDF',
] as const;

export type ReportingFormatOption = typeof REPORTING_FORMAT_OPTIONS[number];
